(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (() => {
  const observed = new WeakSet();
  const fit = (link) => {
    const title = link.querySelector('p');
    if (!title || !link.clientWidth) return;
    const max = window.matchMedia('(max-width:749px)').matches ? 13 : 14;
    title.style.setProperty('font-size', max + 'px', 'important');
    let size = max;
    while (title.scrollWidth > title.clientWidth + 1 && size > 9) {
      size -= 0.25;
      title.style.setProperty('font-size', size + 'px', 'important');
    }
  };
  const observer = new ResizeObserver(entries => entries.forEach(entry => fit(entry.target)));
  let queued = false;
  const update = () => {
    queued = false;
    document.querySelectorAll('product-card [ref="productTitleLink"]').forEach(link => {
      if (!observed.has(link)) {
        observed.add(link);
        observer.observe(link);
      }
      fit(link);
    });
  };
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  };
  const start = () => {
    schedule();
    new MutationObserver(schedule).observe(document.querySelector('main') || document.body, {childList:true, subtree:true});
    document.fonts.ready.then(schedule);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
